import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { useRouteMatch } from 'react-router-dom'
import { DateTime } from 'luxon'
import { useStores } from '@trivie/core'
import { TableHelper } from '../../../../tables'
import { QuizTable } from '../../../../tables/quiz-table'

const Quizzes: React.FunctionComponent = observer(() => {
  const { groupStore } = useStores()

  const { setSelectedGroupId, selectedGroupId, refreshOverviewData } = groupStore

  const match = useRouteMatch<any>('/people/groups/:id/quizzes')
  const groupID = Number(match?.params.id)

  const [tableHelper] = useState(
    new TableHelper('list_group_quizzes', 'quizzes', 'groups', groupID),
  )

  useEffect(() => {
    if (!selectedGroupId) {
      setSelectedGroupId(Number(match?.params.id))
      refreshOverviewData(
        DateTime.local(1971).startOf('day').toISO(),
        DateTime.local().endOf('day').toISO(),
      )
    }
  }, [])

  return <QuizTable tableHelper={tableHelper} />
})

export const GroupsQuizzesTab = (props: any) => {
  const { id } = props
  return {
    name: 'Quizzes',
    path: `/people/groups/${id}/quizzes`,
    component: () => <Quizzes />,
  }
}
